import FirmPhonesCard from "@/components/features/settings/firm/FirmPhonesCard";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/communication")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.firmSettingsPhoneNumbers)) {
    return <GlobalNotAuthorized />;
  }

  return <FirmPhonesCard />;
}
